var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2162 0.881697C15.6037 0.425822 16.2874 0.370388 16.7433 0.757881C17.1991 1.14538 17.2546 1.82906 16.8671 2.28493L7.65875 13.1183C7.26517 13.5813 6.56779 13.6301 6.11358 13.2263L1.23859 8.89301C0.791405 8.49551 0.751123 7.81077 1.14862 7.36359C1.54611 6.91641 2.23086 6.87613 2.67804 7.27362L6.72521 10.8711L15.2162 0.881697Z",
    fill: "#77A600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.3707c10f1322fb074a161a5bbbd7d10b.svg";
export { ForwardRef as ReactComponent };